import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { Search, Dna, Atom, Microscope, ArrowRight, Loader } from 'lucide-react'
import { getAllResearchGroups } from '../services/firestore'
import './ResearchGroups.css'

const ResearchGroups = () => {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState('');
  const [researchGroups, setResearchGroups] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadGroups();
  }, []);

  const loadGroups = async () => {
    setLoading(true);
    const result = await getAllResearchGroups();
    if (result.success) {
      setResearchGroups(result.data);
    }
    setLoading(false);
  };

  const getRandomIcon = (index) => {
    const icons = [<Atom size={24}/>, <Dna size={24}/>, <Microscope size={24}/>];
    return icons[index % icons.length];
  };

  const getRandomColor = (index) => {
    const colors = ['#0ea5a3', '#3b82f6', '#f59e0b', '#ec4899', '#8b5cf6'];
    return colors[index % colors.length];
  };

  const filteredGroups = researchGroups.filter(group =>
    group.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
    group.abbr.toLowerCase().includes(searchTerm.toLowerCase())
  );

  if (loading) {
    return (
      <div className="research-groups-page">
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: '60vh', color: '#1A2B5B' }}>
          <Loader size={48} className="spinner" />
          <p>Cargando grupos de investigación...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="research-groups-page">
      <div className="groups-list-view container">
        <div className="list-header" style={{ marginTop: '20px' }}>
          <h2>Grupos de Investigación</h2>
          <p>Descubre los equipos que están transformando la ciencia. Únete a proyectos colaborativos y expande tus conocimientos.</p>
        </div>

        <div className="search-bar-container">
          <Search className="search-icon" size={20} />
          <input
            type="text"
            className="search-input"
            placeholder="Buscar por nombre o siglas..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>

        <div className="groups-grid-full">
          {filteredGroups.length > 0 ? (
            filteredGroups.map((group, index) => (
              <div
                key={group.id}
                className="group-card"
                onClick={() => navigate(`/research-group/${group.id}`)}
              >
                <div className="group-card-header">
                  <div className="group-abbr" style={{ backgroundColor: getRandomColor(index) }}>
                    {group.abbr}
                  </div>
                  <div className="group-icon-wrapper" style={{ color: getRandomColor(index) }}>
                    {getRandomIcon(index)}
                  </div>
                </div>
                <h4 className="group-card-title">{group.name}</h4>
                <p className="group-card-description">{group.description}</p>
                <div className="group-tags">
                  {group.tags && group.tags.map((tag, tagIndex) => (
                    <span key={tagIndex} className="group-tag">{tag}</span>
                  ))}
                </div>
              </div>
            ))
          ) : (
            <div className="no-results">
              No se encontraron grupos que coincidan con tu búsqueda.
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default ResearchGroups